import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import { SkeletonRelatedWorkList } from '../../common/ui/skeleton/SkeletonRelatedWorkList.tsx';
import type { Props } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyRelatedWorkList = lazy(() =>
	import(/* webpackChunkName: "async-related-work-list" */ './index').then(
		(module) => module.RelatedWorkList,
	),
);

export const RelatedWorkList = (props: Props): React.JSX.Element => (
	<Placeholder
		name="related-work-list"
		fallback={<SkeletonRelatedWorkList numLinks={props.relatedWorkEdges.length} />}
	>
		<LazyRelatedWorkList {...props} />
	</Placeholder>
);
